import React from 'react';
import { useStoreContext } from '../../../App/StoreProvider';
import * as EquipmentProfileActions from '../../../../store/actions/equipmentProfile';
import './EquipmentProfileNavBar.scss';
import EquipmentNotes from './EquipmentNotes';
import EquipmentProgress from './EquipmentProgress/EquipmentProgress';
import {
    GetAssestLoadsByLoadId_getAssestLoadsByLoadId as AssetLoadType,
} from '../../../../types/schemaTypes';

interface EquipmentProfileNavProps {
    loadId: number;
    assetLoad: AssetLoadType | undefined;
}

const EquipmentProfileNav = ({ loadId, assetLoad }: EquipmentProfileNavProps): React.ReactElement => {
    const [state, dispatch] = useStoreContext();
    const { equipmentProfile } = state;

    const getNavigationComponent = (tabs: any, assetLoad: any): React.ReactElement => {
        const selectedTab = tabs.find((tab: any): boolean => {
            return tab.isSelected;
        });

        if (!selectedTab) {
            return <div>No tab selected</div>;
        }

        switch (selectedTab.displayName) {
            case 'Load Progress':
                return <EquipmentProgress loadId={loadId} assetLoad={assetLoad} />
            case 'Load Notes':
                return <EquipmentNotes loadId={loadId} />
            default:
                return <div>No content provided for {selectedTab.displayName}</div>;
        }
    };

    return (
        <React.Fragment>
            <span className="EquipmentProfileNav-TabContainer">
                {equipmentProfile.tabs.map(
                    (tab: any): React.ReactElement => {
                        const tabClass = `EquipmentProfileNav-Tab ${tab.isSelected ? 'EquipmentProfileNav-Selected' : 'EquipmentProfileNav-Unselected'
                            }`;

                        return (
                            <div
                                key={tab.key}
                                className={tabClass}
                                onClick={(): void => dispatch(EquipmentProfileActions.setEquipmentSelectedTab(tab.key))}
                            >
                                <span>
                                    <img
                                        className="EquipmentProfileNav-TabIcon"
                                        src={tab.icon}
                                        alt={`${tab.displayName} Icon`}
                                    />
                                    {tab.displayName}
                                </span>
                            </div>
                        );
                    },
                )}
            </span>
            <div
                className='EquipmentProfileNav-Content'
            >
                {getNavigationComponent(equipmentProfile.tabs, assetLoad)}
            </div>
        </React.Fragment>
    );
};

export default EquipmentProfileNav;
